import { Dispatch, PropsWithChildren, SetStateAction, useEffect } from 'react';
import { BackColor } from "Interfaces/general.interface";

import "GeneralComponents/CSS/_ComponentBackground.min.css";
import Helper from "Interfaces/Helper";

interface Props extends PropsWithChildren {
    componentId: string;
    bgImage?: string;
    bgMobileImage?: string;
    bgImgOpacity?: string;
    backGround: BackColor;
    viewName?: string;
    partialBg?: boolean;
    setLightBg: Dispatch<SetStateAction<boolean>> | null;
}

const ComponentBackground: React.FC<Props> = (props) => {

    const { componentId, setLightBg, bgImgOpacity, children, partialBg, viewName } = props;
    const mediaType = window.matchMedia("(min-width: 576px)");
    const VIEWS_TO_OVERWRITE = ["Links", "API-Loading", "Events"];
    const defaultBg = {
        Color: {
            id: 1,
            label: "#ffffff",
            value: "#ffffff"
        },
        Type: "light"
    };
    const hasOverwriteView = VIEWS_TO_OVERWRITE.some(v => v == viewName);
    const backGround = hasOverwriteView ? defaultBg : props.backGround;
    const bgImage = hasOverwriteView ? null : props.bgImage;


    const setParentLightBg = (isLightBg: boolean) => { if (!!setLightBg) { setLightBg(isLightBg); } };

    const getComponentRoot = () => document.getElementById(componentId);

    const setBGImage = (mediaQuery: MediaQueryList) => {
        try {

            if (bgImage) {

                var componentRoot = getComponentRoot();
                
                const bgMobileImage = props.bgMobileImage ? props.bgMobileImage : bgImage;

                if (mediaQuery.matches) {
                    componentRoot.style.backgroundImage += "url('" + bgImage + "')";
                }
                else {
                    componentRoot.style.backgroundImage += "url('" + bgMobileImage + "')";
                }
                

                componentRoot.classList.add("mst-background");
                switch (Helper.getShadowColor(bgImgOpacity)) {
                    case "Light":
                        componentRoot.classList.add("light-opacity");
                        setParentLightBg(true);
                        break;
                    case "Dark":
                        componentRoot.classList.add("dark-opacity");
                        setParentLightBg(false);
                        break;
                    case "Pallete":
                        componentRoot.classList.add("pallete-opacity");
                        setParentLightBg(false);
                        break;
                    default:
                        componentRoot.classList.add("light-opacity");
                        setParentLightBg(true);
                        break;

                }

                if (partialBg) {
                    componentRoot.classList.add("partial-background");
                }

            }
        }
        catch (e) {

        }
    }

    const setBGColor = (backGround: BackColor, partialBg:boolean ) => {
        try {
            if (backGround.Type) {
                var componentRoot = getComponentRoot();

                componentRoot.style.backgroundColor = backGround.Color.label;


                componentRoot.classList.add("mst-background");


                if (backGround.Type == "dark") {
                    setParentLightBg(false);
                    componentRoot.classList.add("dark-bg");
                }
                else {
                    setParentLightBg(true);
                    componentRoot.classList.add("light-bg");
                }

                if (partialBg) {
                    componentRoot.classList.add("partial-background");
                }
            }


        }
        catch (e) {

        }
    }

    useEffect(() => {
        if (bgImage) { setBGImage(mediaType); }
        else if (backGround) { setBGColor(backGround, partialBg); }
    }, []);


    return <>{children}</>

}

export default ComponentBackground;